import { Injectable } from "@angular/core";
import { eGridArea } from "@hub/generated/enums";
import { SearchParameters } from "@hub/generated/models";
import { SortMeta } from "primeng/api";

@Injectable({ providedIn: 'root' })
export class GridService {
  constructor() {}
  
  private _lastGridArea: eGridArea;
  private _lastGridId: string;

  get lastGridArea() {
    return this._lastGridArea;
  }
  set lastGridArea(area: eGridArea) {
    this._lastGridArea = area;
  }

  get lastGridId() {
    return this._lastGridId;
  }
  set lastGridId(id: string) {
    this._lastGridId = id;
  }

  lastSearchParameters: SearchParameters;
}
